export const paths = {
  DOCUMENT_SELECT: "/document/select",
  MARKUPS_CREATE: "/markups/create",
  MARKUPS_LIST: "/markups/list",
  MARKUPS_APPLY: "/markups/apply",
  LOGIN: "/login",
  JARVIS_LOGIN: "/",
};
